/*
 * @Author: zhangjiangpo
 * @Date: 2024-09-05 14:13:47
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-09-05 14:52:10
 * @Description:
 */
import Store from '../store'
export default {
  install(Vue) {
    Vue.directive('gdd-hide', {
      // 当绑定元素插入到 DOM 中时调用
      inserted(el, binding) {
        const userInfo = Store.getters['userInfo/userInfo']
        // 根据绑定的值决定元素是否显示
        if (userInfo?.gddHide) {
          el.style.display = 'none' // 隐藏元素
        }
      }
    })
  }
}